<template>
  <woot-modal :show.sync="show" :on-close="onCancel" size="modal-xl">
    <contact-manage-view
      :key="contactManageViewKey"
      :contactId="contactIdToUse"
      :ticketSelected="ticketSelected"
      @close-modal-ticket="updateListAndClose"
      @updateTicket="updateTicket"
    />
  </woot-modal>
</template>

<script>
import ContactManageView from '../../contacts/pages/ContactManageView.vue';
export default {
  name: 'ModalEditTicket',
  components: {
    ContactManageView
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ticketSelected: {
      type: Object,
      default: () => ({}),
    },
    column: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      ticket: this.ticketSelected
    }
  },
  computed: {
    contactManageViewKey() {
      return `contact-manage-${this.ticketSelected && this.ticketSelected.id ? this.ticketSelected.id : 'new'}`;
    },
    contactIdToUse() {
      return (
        (this.ticketSelected &&
          this.ticketSelected.contact &&
          this.ticketSelected.contact.id) ||
        (this.ticket && this.ticket.contact && this.ticket.contact.id) ||
        null
      );
    },

    isCrmPage() {
      return this.$route.name === 'crm' || this.$route.name === 'crm_ticket';
    },

  },

  methods: {
    updateListAndClose(action){
      // Remove from current board when: delete, win/lose, deleted status, or reopen (to refresh view)
      const shouldRemove = action === true || action === 'reopen' ||
        ['gain', 'lose', 'deleted'].includes(this.ticket?.status);
      if(shouldRemove && this.ticket?.id){
        this.$store.dispatch('removeTicketFromState', this.ticket.id);
      }
      this.onCancel();
    },

    updateTicket(updatedTicket){
      this.ticket = { ...this.ticket, ...updatedTicket };
      this.$emit('updateTicket', this.ticket);
    },

    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('success');
    },
  },
  watch: {
    ticketSelected: {
      immediate: true,
      handler(ticket) {
        this.ticket = ticket || {};
      },
    },
  },

};
</script>

<style scoped>
.card-content {
  display: flex;
  gap: 2rem;
}

.description {
  min-width: 220px;
}
</style>
